import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Address from 'components/Address';
import { ReactComponent as Trucksvg } from 'images/truck.svg';
import WidgetContainer from 'components/widget/WidgetContainer';
import { FullWidthPaperContent } from 'components/Paper';
import PaneCTA from 'components/widget/PaneCTA';
import addressesPath from 'containers/paths/AddressesContainerPath';
import TextLink from 'components/TextLink';

const Wrapper = styled(WidgetContainer)`
  .addressWrapper {
    display:flex;
    svg {
      height: 64px;
      width: 64px;
      flex-shrink:0;
      margin-right: ${({ theme }) => theme.spacing * 2}px;
    }

    .Address {
      flex-grow:1;
      margin-top:${({ theme }) => theme.spacing}px;

    }
  }

  &.savedAddress {
    .addressWrapper .Address{
      font-size: ${({ theme }) => theme.typography.small.fontSize};
    }

    li:first-child{
      font-family: ${({ theme }) => theme.typography.h3.fontFamily};
      font-weight: ${({ theme }) => theme.typography.h3.fontWeight};
      font-size: ${({ theme }) => theme.typography.h3.fontSize};
    }
  }
`;

const DEFAULT_DELIVERY_TITLE = 'Your primary address';

const Component = ({ className, address }) => {
  const classes = ['DeliveryAddress'];
  if (className) classes.push(className);
  if (!address.is_default) classes.push('savedAddress');
  return (

    <Wrapper className={classes.join(' ')} noRoundedCorners>
      <FullWidthPaperContent className="section">
        <PaneCTA
          heading={address.is_default && <>{DEFAULT_DELIVERY_TITLE}</>}
          linkProps={{ to: addressesPath({ addressId: address.id }, 'set') }}
          dataLayer={{
            action: 'Address Option Click',
            label: 'Address Option Selected',
          }}
        >
          <div className="addressWrapper">
            {address.is_default && (
            <Trucksvg />
            )}
            <Address address={address} />
          </div>
        </PaneCTA>
        {!address.is_default && (
          <TextLink
            props={{ to: addressesPath({ addressId: address.id }, 'delete') }}
            // dataLayer={{ action: 'Skip a Pack', label: 'Skip a Pack - Start' }}
            // todo need this info from specs
            rightChevron
          >
            Delete this address
          </TextLink>
        )}
      </FullWidthPaperContent>
    </Wrapper>
  );
};

Component.propTypes = {
  className: PropTypes.string,
  address: PropTypes.shape({
    id: PropTypes.string.isRequired,
    is_default: PropTypes.bool.isRequired,
  }).isRequired,
};

Component.defaultProps = {
  className: null,
};

Component.displayName = 'DeliveryAddress';

export default Component;
